import { Button, Flex, Table, Tbody, Td, Tfoot, Th, Thead, Tr, Checkbox } from '@chakra-ui/react'
import { Loading } from '../../components/Loading'
import { Pagination } from '../../components/Pagination'
import { TableWrapper } from '../../components/TableWrapper'
import { IConcept } from '../../data/concepts'
import { useGetOffers } from '../../model/api/offers/useGetOffers'
import { CONCEPTS_LIST_PAGE_LIMIT } from '../../pages/chaloupka/constats'
import { calculateTotalPages } from '../../utils/calculateTotalPages'
import { ConceptRow } from './ConceptRow'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const ConceptsList = ({
  params,
  setParams,
  withPaginator = false,
  isDeleting,
  itemsToDelete = [],
  setItemsToDelete,
  onNumberOfConcepts,
}: {
  params?: any
  setParams?: (params: any) => void
  concepts: Array<IConcept>
  withPaginator?: boolean
  isDeleting?: boolean
  itemsToDelete?: any[],
  setItemsToDelete?: any,
  onNumberOfConcepts?: (value: number) => void
}) => {
  const { data, isLoading } = useGetOffers({ ...params })
  const navigate = useNavigate()
  const [startPage, setStartPage] = useState<number>(1)
  const [endPage, setEndPage] = useState<number>(10)
  useEffect(() => {
    if (data?.data.count && onNumberOfConcepts) {
      onNumberOfConcepts(data.data.count)
    }
  }, [data, onNumberOfConcepts])

  if (isLoading) {
    return <Loading />
  }

  const items = data?.data.items ?? [];
  const allChecked = itemsToDelete.length === items.length;
  const isIndeterminate = itemsToDelete.length > 0 && !allChecked
console.log(itemsToDelete);
  return (
    <TableWrapper>
      <Table cellPadding="0" cellSpacing="0">
        <Thead>
          <Tr>
            {isDeleting && (
              <Th>
                <Checkbox
                  isChecked={allChecked}
                  isIndeterminate={isIndeterminate}
                  onChange={(e) => {
                    setItemsToDelete(e.target.checked ? items.map(i => i.id) : []);
                  }}
                />
              </Th>
            )}
            <Th>
              <p>Číslo nabídky</p>
              <p>Stav</p>
            </Th>

            <Th>
              <p>Datum vytvoření</p>
              <p>Datum zahájení</p>
            </Th>

            <Th sx={{ px: 0 }}>{/* <!-- Space for initials --> */}</Th>

            <Th sx={{ pl: 0 }}>
              <p>Pojistník</p>
            </Th>

            <Th>
              <p>Pojišťovna</p>
            </Th>

            <Th>
              <p>Název nabídky</p>
              <p>Zpracoval</p>
            </Th>

            <Th>{/* <!-- Space for status --> */}</Th>

            <Th>{/* <!-- Space for buttons --> */}</Th>
          </Tr>
        </Thead>

        <Tbody>
          {data?.data.items &&
            data?.data.items.length > 0 &&
            data?.data.items.map((concepts, index) => {
              const isDeletingItem = !!itemsToDelete.find((itemToDelete) => itemToDelete === concepts.id);
              return (
                <ConceptRow
                  key={index}
                  {...concepts}
                  isDeleting={isDeleting}
                  itemToDelete={isDeletingItem}
                  setItemToDelete={(checked: boolean) => {
                    if (!checked) {
                      setItemsToDelete(itemsToDelete.filter((itemToDelete) => itemToDelete !== concepts.id))
                    } else {
                      setItemsToDelete([...itemsToDelete, concepts.id])
                    }
                  }}
                />
              )
            })}
        </Tbody>

        <Tfoot>
          <Tr>
            {isDeleting && (
              <Td></Td>
            )}
            <Td colSpan={8}>
              {withPaginator && (
                  <Pagination
                    totalPages={calculateTotalPages(data?.data.count, CONCEPTS_LIST_PAGE_LIMIT)}
                    currentPage={params.page}
                    queryParams={params}
                    setQueryParams={setParams}
                    startPage={startPage}
                    endPage={endPage}
                    onSetStartPage={setStartPage}
                    onSetEndPage={setEndPage}
                    count={data?.data.count}
                  />
              )}

              {!withPaginator && (
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => navigate(`/sme/concepts`)}
                >
                  Více neuzavřených nabídek
                </Button>
              )}
            </Td>
          </Tr>
        </Tfoot>
      </Table>
    </TableWrapper>
  )
}
